<template>
  <ion-app class="hide-top-bar">
    <ion-router-outlet />
  </ion-app>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { IonApp, IonRouterOutlet } from '@ionic/vue';
import { useAuth } from '@/composables/useAuth';

const { init } = useAuth();

onMounted(async () => {
  await init();
});
</script>
